(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  function initPurchaseOptions(root) {
    var fieldset = root.querySelector('[data-purchase-options]');
    if (!fieldset) return;
    var hiddenInput = root.querySelector('[data-selling-plan-input]');
    var frequency = fieldset.querySelector('[data-po-frequency]');
    var select = fieldset.querySelector('[data-po-frequency-select]');
    var radios = fieldset.querySelectorAll('[data-po-radio]');
    var subPriceEl = fieldset.querySelector('[data-po-sub-price]');
    function setActiveState() {
      fieldset.querySelectorAll('[data-po-option]').forEach(function (opt) {
        var input = opt.querySelector('[data-po-radio]');
        opt.classList.toggle('is-active', !!(input && input.checked));
      });
    }
    function selectedFrequencyValue() { return select ? (select.value || '') : ''; }
    function selectedFrequencyPrice() {
      if (!select || select.selectedIndex < 0) return '';
      var opt = select.options[select.selectedIndex];
      return opt ? (opt.getAttribute('data-plan-price') || '') : '';
    }
    function applySubscribe() { if (frequency) frequency.hidden = false; if (hiddenInput) hiddenInput.value = selectedFrequencyValue(); }
    function applyOnetime() { if (frequency) frequency.hidden = true; if (hiddenInput) hiddenInput.value = ''; }
    function currentMode() { var c = fieldset.querySelector('[data-po-radio]:checked'); return c ? c.value : 'onetime'; }
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.value === 'subscribe' && radio.checked) applySubscribe();
        else if (radio.value === 'onetime' && radio.checked) applyOnetime();
        setActiveState();
      });
    });
    if (select) {
      select.addEventListener('change', function () {
        if (currentMode() === 'subscribe' && hiddenInput) hiddenInput.value = selectedFrequencyValue();
        if (subPriceEl) { var p = selectedFrequencyPrice(); if (p) subPriceEl.textContent = p; }
      });
    }
    root.addEventListener('variant:changed', function () {
      var onetime = fieldset.querySelector('[data-po-radio][value="onetime"]');
      if (onetime) onetime.checked = true;
      applyOnetime();
      setActiveState();
    });
    applyOnetime();
    setActiveState();
  }
  function boot() { document.querySelectorAll('.product[data-section-id]').forEach(initPurchaseOptions); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { if (e.target) initPurchaseOptions(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-dosage-chart"] && !Shopify.designMode) return;
  try {
    
(function () {
  function clamp(value, min, max) {
    if (value < min) return min;
    if (value > max) return max;
    return value;
  }

  // Round to at most one decimal place, drop a trailing ".0".
  function tidy(num) {
    var rounded = Math.round(num * 10) / 10;
    if (Number.isNaN(rounded) || !Number.isFinite(rounded)) return '0';
    return String(rounded);
  }

  function initCalc(root) {
    if (root.dataset.dosageBound === 'true') return;
    root.dataset.dosageBound = 'true';

    var input = root.querySelector('[data-dosage-input]');
    var outThreads = root.querySelector('[data-dosage-out-threads]');
    var outWater = root.querySelector('[data-dosage-out-water]');
    if (!input || !outThreads || !outWater) return;

    var threadsPer = parseFloat(root.dataset.threadsPer) || 10;
    var waterPer = parseFloat(root.dataset.waterPer) || 2;
    var servingsPer = parseFloat(root.dataset.servingsPer) || 4;
    if (servingsPer < 1) servingsPer = 1;

    var min = parseInt(root.dataset.min, 10);
    var max = parseInt(root.dataset.max, 10);
    if (Number.isNaN(min)) min = 1;
    if (Number.isNaN(max)) max = 50;
    if (max < min) max = min;

    function compute() {
      var raw = parseFloat(input.value);
      // Guard against empty / NaN: fall back to the minimum, never NaN output.
      if (Number.isNaN(raw)) raw = min;
      var servings = clamp(raw, min, max);

      var threads = Math.round((servings * threadsPer) / servingsPer);
      var water = (servings * waterPer) / servingsPer;

      outThreads.textContent = String(threads);
      outWater.textContent = tidy(water);
    }

    function normalizeInput() {
      var raw = parseFloat(input.value);
      if (Number.isNaN(raw)) raw = min;
      input.value = String(clamp(Math.round(raw), min, max));
      compute();
    }

    input.addEventListener('input', compute);
    input.addEventListener('change', normalizeInput);
    input.addEventListener('blur', normalizeInput);

    root.querySelectorAll('[data-dosage-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.dataset.dosageStep, 10) || 0;
        var current = parseFloat(input.value);
        if (Number.isNaN(current)) current = min;
        input.value = String(clamp(Math.round(current) + delta, min, max));
        compute();
      });
    });

    compute();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-dosage-calc]').forEach(initCalc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Theme editor: re-init when this section is loaded / re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
